module.exports = __webpack_public_path__ + "static/media/leftls.4f359b71.png";